import DatesTable from '../components/dates-table';
import Slider from '../components/slider';

export default {
  init() {
    // Init dates tabel
    new DatesTable($('#dates-table'));

    // Init selected dates slider
    const datesSliders = document.querySelector('.o-section--selected-dates .o-slider');

    this.slider = new Slider(datesSliders, {
      slidesPerView: 1,
      spaceBetween: 0,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/dates.js